import React from 'react';
import { Platform } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createStackNavigator } from '@react-navigation/stack';
import type { HomeStackParamList } from '@/types/navigation';
import HomeScreen from '@/screens/HomeScreen';
import MeetingAnnouncementScreen from '@/screens/MeetingAnnouncementScreen';

// Use regular stack navigator on web
const NativeStack = createNativeStackNavigator<HomeStackParamList>();
const WebStack = createStackNavigator<HomeStackParamList>();
const Stack = Platform.OS === 'web' ? WebStack : NativeStack;

const HomeStack: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        ...(Platform.OS === 'web' ? {
          animationEnabled: false,
          cardStyle: { flex: 1 },
        } : {
          gestureEnabled: true,
          gestureDirection: 'horizontal',
          animation: 'slide_from_right',
        }),
      }}
    >
      <Stack.Screen 
        name="HomeRoot" 
        component={HomeScreen}
        options={Platform.OS === 'web' ? {} : {
          animation: 'none',
        }}
      />
      <Stack.Screen 
        name="MeetingAnnouncement" 
        component={MeetingAnnouncementScreen}
        options={Platform.OS === 'web' ? {} : {
          animation: 'slide_from_right',
          animationDuration: 350,
          gestureEnabled: true,
          gestureDirection: 'horizontal',
          fullScreenGestureEnabled: true,
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  );
};

export default HomeStack;
